import axios from "axios";
import { jwtDecode } from "jwt-decode";

const MAX_RETRIES = 3;
const TIMEOUT = 5000;
var auxUser = null;

// Obtener un cliente completo
export async function getClient(client, domain) {
  for (let i = 0; i < MAX_RETRIES; i++) {
    try {
      let res = await axios.get(
        `https://api.workobot.com/dev/archibot/get-client?client=${client}&domainName=${domain}`,
        {
          timeout: TIMEOUT,
        }
      );

      if (res.status === 200) {
        return res.data;
      } else {
        throw new Error(`Respuesta no exitosa: ${res.status}`);
      }
    } catch (error) {
      if (i === MAX_RETRIES - 1) {
        console.log("error", error);
        return null;
      }
    }
  }
}

export async function LoginWK(user, pass, hubCode) {
  let data = JSON.stringify({
    requestType: "loginUser",
    user: {
      user: user,
      pass: pass,
      hub: hubCode,
    },
  });
  try {
    let response = await axios.post(
      "https://api.workobot.com/dev/archibot",
      data
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return { status: "Error", message: e };
  }
}

export async function getUser(user, hubCode) {
  // console.log(user);
  let data = JSON.stringify({
    requestType: "getBasicUser",
    user: {
      user: user.email,
      hub: hubCode,
    },
  });
  try {
    let response = await axios.post(
      "https://api.workobot.com/dev/archibot",
      data
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return { status: "Error", message: e };
  }
}

export async function LoginGoogle(jwt, hubCode) {
  let user = jwtDecode(jwt);

  // console.log({ user });

  let res = await getUser(user, hubCode);
  if (res.Message === "VALID USER") {
    return res;
  } else if (res.Message === "INVALID USER") {
    let newUser = {
      email: user.email,
      fullName: user?.name,
      password: "*****",
      phone: "",
      apps: {},
    };
    let res2 = await Register(newUser, hubCode);
    // console.log("Entro con", newUser, res2);

    if (res2.Message === "USER CREATED SUCCESSFULLY") {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      let res3 = await getUser(user, hubCode);
      return res3;
    }
  }
}

export async function getMicrosoftUser(accessToken, hubCode) {
  try {
    const response = await axios.get("https://graph.microsoft.com/v1.0/me", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const microsoftUser = response.data;

    let res = await getUser(
      { email: microsoftUser.mail || microsoftUser.userPrincipalName },
      hubCode
    );

    if (res.Message === "VALID USER") {
      return microsoftUser;
    } else if (res.Message === "INVALID USER") {
      // Create a new user if not found
      let newUser = {
        email: microsoftUser.mail || microsoftUser.userPrincipalName,
        fullName: microsoftUser.displayName,
        password: "*****",
        phone: "",
        apps: {},
      };

      let res2 = await Register(newUser, hubCode);

      if (res2.Message === "USER CREATED SUCCESSFULLY") {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        // Return the Microsoft user data
        return microsoftUser;
      } else {
        throw new Error("User creation failed");
      }
    } else {
      throw new Error("Unexpected response from getUser");
    }
  } catch (error) {
    console.error("Error during Microsoft Login", error);
    return { status: "Error", message: error.message };
  }
}

export function getUserJS() {
  return auxUser;
}

export function setUserJS(user) {
  auxUser = user;
}

export async function Register(user, hubCode) {
  let data = JSON.stringify({
    requestType: "newUser",
    user: {
      user: user.email,
      hub: hubCode,
      hubVersion: "1.0.0.0",
      userNames: user.fullName,
      pass: user.password,
      tel: user.phone,
      userType: "USER",
      apps: user?.apps ?? {},
    },
  });
  try {
    let response = await axios.post(
      "https://api.workobot.com/dev/archibot",
      data
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return { status: "Error", message: e };
  }
}

export async function sendVerificationCode(email) {
  const generateVerificationCode = (length) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const verificationCode = generateVerificationCode(6);

  // console.log(verificationCode, email);

  // return verificationCode;

  const data = JSON.stringify({
    requestType: "sendEmail",
    sendEmail: {
      toEmail: [email],
      // toEmail: ["testermail760@gmail.com"],
      fromEmail: "soporte@workobot.com",
      replyTo: ["soporte@workobot.com"],
      emailSubject: "Código de Verificación",
      htmlBody: `<div>Su código de verificación es: <strong>${verificationCode}</strong></div>`,
      textBody: `Su código de verificación es: ${verificationCode}`,
      textAttachments: [
        {
          "content-type": "application/txt",
          name: "VerificationCode.txt",
          data: `Su código de verificación es: ${verificationCode}`,
        },
      ],
    },
  });

  try {
    let response = await axios.post(
      "https://api.workobot.com/dev/archibot",
      data
    );
    //const response = await axios(config);
    // console.log(response);

    if (response.status === 200) {
      return verificationCode;
    } else {
      console.error("Error al enviar el correo:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error al enviar el correo:", error);
    return null;
  }
}

export async function sendRecoveryPass(email, hubCode) {
  const data = JSON.stringify({
    requestType: "recoverPass",
    user: {
      user: email,
      hub: hubCode,
    },
  });

  try {
    const response = await axios.post(
      "https://api.workobot.com/dev/archibot",
      data
    );

    if (response.status === 200) {
      console.log("Correo enviado exitosamente:", response.data);
      return "ok";
    } else {
      console.error("Error al enviar el correo:", response.data);
      return null;
    }
  } catch (error) {
    console.error(
      "Error al enviar el correo:",
      error.response?.data || error.message
    );
    return null;
  }
}
